<template>
  <div class="panel custom-wrapper">
    <div class="row">
      <div class="col-md-5">
        <contact
          ref="client"
          :isFirm="isFirm"
          @highlightSave="highlightSave"
        />
      </div>
      <div class="col-md-7">
        <contact-communications
          :recordData="contact"
          :stacked="stacked"
          :showTitles="showCommTitles"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Contact from '@/components/contacts/forms/contact'
import ContactCommunications from '@/components/contacts/listings/contact-record'
export default {
  name: 'contact-basic',
  components: {
    Contact,
    ContactCommunications
  },
  props: {
    isFirm: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      stacked: true,
      showCommTitles: true
    }
  },
  computed: {
    ...mapGetters('contacts', ['contact'])
  },
  methods: {
    async performSave() {
      return this.$refs.client.performSave()
    },
    highlightSave(value) {
      this.$emit('highlightSave', value)
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-wrapper {
  overflow: auto;
  overflow-x: hidden;
  max-height: 500px;
  padding-left: 15px;
  padding-right: 30px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/contacts/forms/contact-basic.vue